module.exports = __webpack_public_path__ + "img/pic-03.02919ad3.png";